import { NotFound } from '@containers';

export default [
  {
    path: '*',
    component: NotFound,
  },
];
